import {
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import UnauthenticatedLayout from "../layout/UnauthenticatedLayout";

interface Props {}

const NotFoundPage: FunctionComponent<Props> = (props: Props): JSX.Element => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  return (
    <UnauthenticatedLayout>
      <Stack padding={2} spacing={4} alignItems={"center"} textAlign={"center"}>
        <Typography variant={isSmallScreen ? "h4" : "h2"}>
          404 - Not Found
        </Typography>
        <Typography variant="body1">
          Sorry we could not find the page you are looking for.
        </Typography>

        <Button
          variant="contained"
          size={isSmallScreen ? "small" : "medium"}
          sx={{ width: "fit-content" }}
          onClick={() => navigate("/")}
        >
          Home
        </Button>
      </Stack>
    </UnauthenticatedLayout>
  );
};

export default NotFoundPage;
